module.exports = __webpack_public_path__ + "static/media/hello_logo.b7204f30.png";